import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ProductModel } from "src/api/product/product-types";
import { BaseButton, BaseRadio } from "src/components";
import MarkdownEditor from "src/components/MarkdownEditor";
import useUsageApplication, { ProductApplication } from "src/pages/product/hooks/useUsageApplication";
import { useModal } from "src/recoil/modalState/hook";

type Props = {
  onClose: () => void;
  productApplication?: ProductApplication | null;
  product?: ProductModel;
  applicationData?: any;
};

const defaultApplicationForm = {
  isUseApplication: false,
  formData: {
    richText: "",
    attachmentConfig: {
      isRequired: false,
    },
  },
};

const UsageApplicationProductForm = ({ onClose, productApplication, product, applicationData }: Props) => {
  const { pathname } = useLocation();
  const isProductPage = pathname.includes("/product/");

  // 공간상품 이용신청서 조회 api
  const queryClient = useQueryClient();

  const { setBaseModal } = useModal();

  const { updatePrApplication } = useUsageApplication();

  const [applicationForm, setApplicationForm] = useState<ProductApplication>(productApplication || defaultApplicationForm);

  const onUpdatePrApplication = () => {
    setBaseModal({
      isOpen: true,
      title: "저장하시겠습니까?",
      onClick: () => {
        execute();
        setBaseModal({ isOpen: false });
      },
      onClose: () => {
        setBaseModal({ isOpen: false });
      },
      btnRightTitle: "확인",
      btnLeftTitle: "취소",
    });

    const execute = async () => {
      const result = await updatePrApplication(applicationForm, product || undefined);
      if (result) {
        queryClient.invalidateQueries({
          queryKey: ["getProductDetailAsync", product?.id],
        });
        onClose();
      }
    };
  };

  return (
    <>
      <section className="base-abstract-modal__title flex-center-between border-bottom-gray ">
        <h1>이용신청서</h1>
      </section>

      <section className="base-abstract-modal__contents ">
        <article className="contents-container__wrap-article">
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p>사용 여부</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <div className="flex-center">
                  <BaseRadio
                    id={"useApplication1"}
                    name={"useApplication"}
                    label={"미사용"}
                    onChange={(_: boolean) => {
                      setApplicationForm((prev) => ({
                        ...prev,
                        isUseApplication: false,
                      }));
                    }}
                    className="mr16"
                    checked={!applicationForm.isUseApplication || false}
                  />
                  <BaseRadio
                    id="useApplication2"
                    name="useApplication"
                    label="사용"
                    onChange={(_: boolean) => {
                      setApplicationForm((prev) => ({
                        ...prev,
                        isUseApplication: true,
                      }));
                    }}
                    className="mr16"
                    checked={applicationForm.isUseApplication || false}
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p>상세 내용</p>
            </div>
            <div className="contents-container__grid-contents contents-container__1200">
              <div className="minmax627">
                <MarkdownEditor
                  value={applicationForm.formData.richText || ""}
                  onChange={(value?: string) => {
                    setApplicationForm((prev) => ({
                      ...prev,
                      formData: { ...prev.formData, richText: value ?? "" },
                    }));
                  }}
                  errorText={""}
                  height="410px"
                />
              </div>
            </div>
          </section>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              {/* <p className={isUseApplication && isUseApplication === true ? "required" : ""}>첨부파일</p> */}
              <p>첨부파일</p>
            </div>

            <div className="contents-container__grid-contents contents-container__1200">
              <div>
                <div className="flex-center-start">
                  <BaseRadio
                    id={"uploadFile1"}
                    name={"uploadFile"}
                    label={"선택"}
                    onChange={(_: boolean) => {
                      setApplicationForm((prev) => ({
                        ...prev,
                        formData: { ...prev.formData, attachmentConfig: { isRequired: false } },
                      }));
                    }}
                    className="mr16"
                    checked={!applicationForm.formData.attachmentConfig?.isRequired || false}
                  />
                  <BaseRadio
                    id="uploadFile2"
                    name="uploadFile"
                    label="필수"
                    onChange={(_: boolean) => {
                      setApplicationForm((prev) => ({
                        ...prev,
                        formData: { ...prev.formData, attachmentConfig: { isRequired: true } },
                      }));
                    }}
                    className="mr16"
                    checked={applicationForm.formData.attachmentConfig?.isRequired || false}
                  />
                </div>
              </div>
            </div>
          </section>
        </article>
      </section>
      <section className="base-abstract-modal__btn-wrap ">
        <div className="flex-center">
          <BaseButton
            title="취소"
            className="color-white mr10"
            onClick={() => {
              setBaseModal({
                isOpen: true,
                title: "작성을 취소하시겠습니까?",
                children: (
                  <div>
                    <p>확인을 누르면 저장되지 않습니다.</p>
                  </div>
                ),
                btnLeftTitle: "취소",
                btnRightTitle: "확인",
                onClick: () => {
                  onClose();
                  setBaseModal({ isOpen: false });
                },
                onClose: () => {
                  setBaseModal({ isOpen: false });
                },
              });
            }}
          />
          <BaseButton title="완료" onClick={() => onUpdatePrApplication()} />
        </div>
      </section>
    </>
  );
};

export default UsageApplicationProductForm;
